import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';
import {slotStore} from '@gongxigames/framework/slotV2/globals';

export class AutoplayStopUIAct extends SyncUIActDecorator {
    public execute(): void {
        this.emitter.emit('UI.updateUIElementsState', 'AutoplayStopUIState');
        this.emitter.on('Game.command.canProceedAutoSpinStop', () => {
            slotStore.isAutoplayStop.value = false;
            this.onExecuted?.();
        });

        this.emitter.on('UI.quickStopButton.pressed', this.onSkipStartedByButton.bind(this));
    }

    protected onSkipStartedByButton(): void {
        this.emitter.emit('UI.command.spin');
    }

    getName(): string {
        return 'AutoplayStopUIAct';
    }
}